export default {
  /**
   * Git Info
   * 在瀏覽器 Console 中輸入 APP_CONFIG 可以查看：
   * commitHash  --> 當前環境運行的 Commit Hash
   * commitTag   --> 當前環境運行的版本號
   */
  commitHash: process.env.COMMIT_HASH,
  commitTag: process.env.COMMIT_TAG,
  /**
   * Feature Flags
   * 設定檔與環境對照如下：
   * .env.localhost --> localhost
   * .env.dev       --> dev
   * .env.sit       --> sit
   * .env.pre       --> pre
   * .env.prod      --> production
   */
  isActived(spec) {
    return (
      process.env.NODE_ENV == 'localhost' ||
      this.isActiveFeature[process.env.NODE_ENV].includes(spec)
    )
  },
  isActiveFeature: {
    // New
    dev: [
      'spec95' // JoeLin
    ],
    sit: [
      'spec95' // JoeLin
    ],
    production: []
  }
}
